import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { ParticipantsControlType } from '@gem/call/Model/callModel.types';
import { useTranslation } from '@gem/modules/i18n';

interface IGroupAudioCallPresenter {
  membersQuantityText: string;
  call: Call;
}

export const useGroupAudioCallPresenter = (): IGroupAudioCallPresenter => {
  const { t } = useTranslation();
  const context = useCallContext();

  const presenter = useLocalObservable<IGroupAudioCallPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get membersQuantityText(): string {
      if (
        presenter.call.uiFeatures.participantsControlType === ParticipantsControlType.WithMaxNumber
      ) {
        return t('calls_users_on_call', {
          0: presenter.call.members.memberDevicesOnCallList.length,
          1: presenter.call.members.memberList.length,
        });
      }
      if (
        presenter.call.uiFeatures.participantsControlType === ParticipantsControlType.TotalNumber
      ) {
        return t('calls_participants_on_call_section_name', {
          0: presenter.call.members.memberDevicesOnCallList.length,
        });
      }
      return t('common_participants');
    },
  }));

  return presenter;
};
